"use strict";
// (C) 2022-2023 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.GranularPermissionSelectItemWithBubble = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var react_intl_1 = require("react-intl");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var Bubble_1 = require("../../../../Bubble");
var locales_1 = require("../../../../locales");
var GranularPermissionSelectItem = function (_a) {
    var permission = _a.permission, grantee = _a.grantee, selectedPermission = _a.selectedPermission, toggleDropdown = _a.toggleDropdown, handleSetSelectedPermission = _a.handleSetSelectedPermission, onChange = _a.onChange;
    var intl = react_intl_1.useIntl();
    var handleOnChange = react_1.useCallback(function (permission) {
        toggleDropdown();
        if (permission.id !== selectedPermission) {
            handleSetSelectedPermission(permission.id);
            onChange(tslib_1.__assign(tslib_1.__assign({}, grantee), { permissions: [permission.id] }));
        }
    }, [grantee, toggleDropdown, handleSetSelectedPermission, onChange, selectedPermission]);
    var isSelected = react_1.useMemo(function () { return permission.id === selectedPermission; }, [permission, selectedPermission]);
    return (react_1.default.createElement("div", { onClick: function () {
            if (permission.enabled) {
                handleOnChange(permission);
            }
        }, className: classnames_1.default("gd-list-item", "gd-menu-item", "gd-granular-permission-select-item", "s-granular-permission-item", {
            "is-disabled": !permission.enabled,
            "is-selected": isSelected,
        }) },
        react_1.default.createElement("div", null, intl.formatMessage(locales_1.granularPermissionMessageLabels[permission.id]))));
};
exports.GranularPermissionSelectItemWithBubble = Bubble_1.withBubble(GranularPermissionSelectItem);
//# sourceMappingURL=GranularPermissionItem.js.map